import { Section, SectionHeading, Stagger, StaggerItem } from "@/components/Section";
import { Stethoscope, HeartPulse, Sparkles, UserRound, Leaf } from "lucide-react";

const CLIENTS = [
  { icon: Stethoscope, name: "Primary Care Clinics", note: "Add margin-rich programs on top of existing panels." },
  { icon: HeartPulse, name: "Wellness Clinics", note: "Bundle wellness programs into recurring memberships." },
  { icon: Sparkles, name: "Med Spas", note: "Standardize supply and patient flow across services." },
  { icon: UserRound, name: "Concierge Practices", note: "Elevate premium offerings with infrastructure." },
  { icon: Leaf, name: "Functional Medicine", note: "Operationalize diagnostics and longevity protocols." },
];

export default function IdealClients() {
  return (
    <Section testId="ideal-clients-section" className="bg-slate-50 border-y border-slate-200">
      <SectionHeading
        eyebrow="Who we serve"
        title="Built for clinics that want to grow without rebuilding operations."
      />

      <Stagger stagger={0.06}>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CLIENTS.map((c, i) => (
            <StaggerItem key={c.name}>
              <div
                data-testid={`ideal-client-${i}`}
                className="h-full rounded-2xl border border-slate-200 bg-white p-6 hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 rounded-lg bg-slate-900 text-white flex items-center justify-center">
                  <c.icon className="w-4.5 h-4.5" strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-display text-base font-semibold text-slate-900 leading-snug">{c.name}</h3>
                <p className="mt-2 text-xs text-slate-600">{c.note}</p>
              </div>
            </StaggerItem>
          ))}
        </div>
      </Stagger>
    </Section>
  );
}
